import {
  Row,
  Container,
  Input,
  Button,
  Col,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import React, { FormEvent, useCallback, useContext, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { AppContext } from "services/appContext/AppContext";
import classNames from "classnames";
import AddCarrierIntegrationModal from "./AddCarrierIntegrationModal";
import CarrierIntegrationTable from "./CarrierIntegrationTable";
export default function CarrierIntegrationDetails() {
  const [searchValue, setSearchValue] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [, setErrorMessageId] = useState("");
  const [focusedSearchInput, setFocusedSearchInput] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { appContext } = useContext(AppContext);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const intl = useIntl();
  const theme = appContext.theme;

  const onPaste = useCallback(
    (e: React.ClipboardEvent<HTMLInputElement>) => {
      e.preventDefault();

      const pasted = e.clipboardData.getData("text").trim();
      const lines = pasted.split(/\r?\n/); // split by lines only

      const phoneRegex = /^\d{10}$/;

      const phones: string[] = [];
      let nonPhoneData = "";

      for (const line of lines) {
        const trimmed = line.trim();

        if (phoneRegex.test(trimmed)) {
          phones.push(trimmed);
        } else if (trimmed) {
          nonPhoneData += (nonPhoneData ? " " : "") + trimmed;
        }
      }

      const allParts = [...phones];
      if (nonPhoneData) {
        allParts.push(nonPhoneData); // add raw string exactly as is (not in quotes)
      }

      const finalValue = allParts.join(",");

      handleSearchChange(finalValue);
    },
    [searchInputValue]
  );

  //     const finalValue = allParts.join(",");

  //     handleSearchChange(finalValue);
  // }, [searchInputValue]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const inputValue = searchInputValue.trim();
    const errorMessageIdResult = validateSearchValue();
    setErrorMessageId(errorMessageIdResult);

    if (!errorMessageIdResult) {
      setSearchValue(inputValue);
    }
  };
  const handleSearchChange = (searchValue: string) => {
    setErrorMessageId("");
    setSearchInputValue(searchValue);
  };

  return (
    <>
      {showModal && (
        <AddCarrierIntegrationModal
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            setRefreshTrigger((prev) => !prev);
          }}
        />
      )}
      <Container className="mb-6">
        <Row>
          <Col md="6" className="offset-md-3">
            <h1 className={`display-3 ${theme === "light" ? "lblue-color" : "pc-soa-order-bg"}`}>
              <FormattedMessage id="carrierIntegration.title" />
            </h1>
          </Col>
        </Row>
        <Row>
          <Col md="3"></Col>
          <Col md="6" xs="12" className="mb-1">
            <Form onSubmit={handleSubmit}>
              <FormGroup
                className={classNames("input-group-merge pc-search-container mb-0", {
                  focused: focusedSearchInput
                })}>
                <InputGroup className="input-group-merge mr-1">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="carrier-integration-search"
                    placeholder={intl.formatMessage({
                      id: "carrierIntegration.search.placeholder"
                    })}
                    value={searchInputValue}
                    onChange={(e) => handleSearchChange(e.currentTarget.value)}
                    onFocus={() => setFocusedSearchInput(true)}
                    onBlur={() => setFocusedSearchInput(false)}
                    onPaste={onPaste}
                  />
                </InputGroup>
                <Button
                  color={`${theme === "dark" ? "warning" : ""}`}
                  type="submit"
                  className={`pc-btn ml-4 ${theme === "light" ? "bg-lblue" : ""}`}>
                  <FormattedMessage id="inventory.search.button" />
                </Button>
              </FormGroup>
            </Form>
          </Col>
          <Col md="3" xs="12" className="mb-1 pl-2">
            <Button
              color={`${theme === "dark" ? "danger" : ""}`}
              className={`pc-btn create-btn ${theme === "light" ? "bg-lblue" : ""}`}
              onClick={() => setShowModal(true)}>
              <i className="fas fa-plus-square mr-2" />
              <FormattedMessage id="carrierIntegration.create" />
            </Button>
          </Col>
        </Row>
      </Container>
      <Container>
        <CarrierIntegrationTable searchValue={searchValue} refreshTrigger={refreshTrigger} />
      </Container>
    </>
  );
}

const validateSearchValue = (): string => {
  return "";
};